import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5414914f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "login" }
const _hoisted_2 = { class: "login-stack" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-logo",
  alt: "Paladium",
  src: "/logo.svg"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-hint" }, "Connectez-vous avec votre compte Microsoft pour jouer.", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"ms-glyph\" viewBox=\"0 0 12 12\" aria-hidden=\"true\" data-v-5414914f><rect x=\"0\" y=\"0\" width=\"5.4\" height=\"5.4\" data-v-5414914f></rect><rect x=\"6.6\" y=\"0\" width=\"5.4\" height=\"5.4\" data-v-5414914f></rect><rect x=\"0\" y=\"6.6\" width=\"5.4\" height=\"5.4\" data-v-5414914f></rect><rect x=\"6.6\" y=\"6.6\" width=\"5.4\" height=\"5.4\" data-v-5414914f></rect></svg>", 1)
const _hoisted_7 = {
  key: 0,
  class: "login-waiting"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ring-spinner",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "buy-minecraft"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "version" }, "Version 1.0.0", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PalaLink = _resolveComponent("PalaLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["ms-btn", { loading: _ctx.inLogin }]),
        disabled: _ctx.inLogin || !_ctx.link,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
      }, [
        _hoisted_6,
        _createTextVNode(" Se connecter avec Microsoft ")
      ], 10, _hoisted_5),
      (_ctx.inLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" Fenêtre Microsoft ouverte, terminez la connexion puis revenez ici. ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createTextVNode(" Pas de compte Minecraft ? "),
            _createVNode(_component_PalaLink, {
              href: "https://www.minecraft.net/fr-fr",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" En acheter un ")
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_component_PalaLink, {
      id: "help-link",
      href: "https://paladium-pvp.fr/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Problème lors de la connexion ? ")
      ]),
      _: 1
    }),
    _hoisted_10
  ]))
}